// extracted by mini-css-extract-plugin
export var active = "index-module--active--9hX1B";
export var personImageContainer = "index-module--personImageContainer--fqooS";